module.exports = __webpack_public_path__ + "static/media/twitter.4adc9d05.svg";